import {rebuildSection} from "./IntegrationDefinitionUtils";
import {commonDashboardExtension} from "./CommonFields";
import {IntegrationCategories} from "./IntegrationConsts";

export const elasticDashboardExtension = rebuildSection( commonDashboardExtension, {
    category: IntegrationCategories.DASHBOARD_EXTENSION,
    integration: "elastic",
    auth_scheme: "none",
    tabTitle: "This will generate an Access Token that will be needed when installing and configuring the Zebrium Zebeat agent."
})